/* Newsletter popup. Markup and settings: sections/cpv-newsletter-popup.liquid */
(function () {
  if (customElements.get('cpv-newsletter-popup')) return;

  var STATE_KEY = 'cpvNewsletterPopup';
  var PAGES_KEY = 'cpvNewsletterPopupPages';
  var DAY = 864e5;

  function read(storageName, key) {
    try {
      return JSON.parse(window[storageName].getItem(key));
    } catch (error) {
      return null;
    }
  }
  function write(storageName, key, value) {
    try {
      window[storageName].setItem(key, JSON.stringify(value));
    } catch (error) {}
  }

  // Finds the Forms block's typing boxes, including inside its open shadow root.
  function findEmailInputs(root) {
    var found = Array.prototype.slice.call(root.querySelectorAll('input:not([type="hidden"])'));
    root.querySelectorAll('*').forEach(function (element) {
      if (element.shadowRoot) found = found.concat(findEmailInputs(element.shadowRoot));
    });
    return found;
  }

  // The phone banner has less black space than the computer one, so on phones the Forms
  // block's boxes get a little shorter. Its styles live in a shadow root, so ours go in there too.
  var PHONE_FORM_CSS =
    '@media (max-width: 899px) {' +
    'form > div:has(> shop-lead-capture) { display: none !important; }' +
    'form { gap: 8px !important; }' +
    'form input { padding-top: 17px !important; padding-bottom: 4px !important; }' +
    'form button { padding-top: 10px !important; padding-bottom: 10px !important; }' +
    '[class*="_gridItemContent_"] { gap: 6px !important; row-gap: 6px !important; }' +
    '[class*="_formDisclaimer_"] { margin-top: 0 !important; line-height: 1.35 !important; }' +
    '}';

  function addPhoneFormStyles(area) {
    var tries = 0;
    var timer = setInterval(function () {
      var host = area.querySelector('shopify-forms-embed');
      var root = host && host.shadowRoot;
      tries += 1;
      if (root && root.querySelector('form')) {
        clearInterval(timer);
        if (root.querySelector('style[data-cpv-nl]')) return;
        var style = document.createElement('style');
        style.setAttribute('data-cpv-nl', '');
        style.textContent = PHONE_FORM_CSS;
        root.appendChild(style);
      } else if (tries > 60) {
        clearInterval(timer);
      }
    }, 250);
    return timer;
  }

  class CpvNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.timers = [];
      var signal = this.abort.signal;

      this.dialog = this.querySelector('dialog');
      this.teaser = this.querySelector('[data-teaser]');
      this.formArea = this.querySelector('.cpv-nl__form');
      if (this.classList.contains('cpv-nl--phone-art')) this.styleTimer = addPhoneFormStyles(this.formArea);
      this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
      this.state = (!this.designMode && read('localStorage', STATE_KEY)) || {};
      if (/[?&]popup_reset\b/.test(window.location.search)) this.state = {};

      this.querySelectorAll('[data-close]').forEach((button) => {
        button.addEventListener('click', () => this.close(), { signal });
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      }, { signal });
      this.dialog.addEventListener('close', () => this.handleClosed(), { signal });
      if (this.teaser) this.teaser.addEventListener('click', () => this.open(), { signal });

      if (this.designMode) {
        var id = this.dataset.sectionId;
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === id) this.open();
        }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          if (event.detail.sectionId === id) this.open();
        }, { signal });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail.sectionId === id) this.close();
        }, { signal });
        return;
      }

      if (this.state.joined) return;
      if (/[?&]popup_reset\b/.test(window.location.search)) {
        write('localStorage', STATE_KEY, this.state);
        this.timers.push(setTimeout(() => this.open(), 1000));
        return;
      }
      this.setTeaser(Boolean(this.state.seenAt));
      this.scheduleAutoOpen();
    }

    disconnectedCallback() {
      this.abort.abort();
      this.timers.forEach(clearTimeout);
      clearInterval(this.watcher);
      clearInterval(this.styleTimer);
    }

    scheduleAutoOpen() {
      var pages = (read('sessionStorage', PAGES_KEY) || 0) + 1;
      write('sessionStorage', PAGES_KEY, pages);
      if (this.isSnoozed() || this.dataset.template === 'cart') return;

      if (pages >= (Number(this.dataset.startPage) || 1)) {
        this.timers.push(setTimeout(() => this.autoOpen(), (Number(this.dataset.delay) || 0) * 1000));
      }

      if (this.dataset.exitIntent === 'true' && window.matchMedia('(pointer: fine)').matches) {
        var armedAt = Date.now() + 3000;
        document.addEventListener('mouseout', (event) => {
          if (!event.relatedTarget && event.clientY <= 0 && Date.now() > armedAt) this.autoOpen();
        }, { signal: this.abort.signal });
      }
    }

    isSnoozed() {
      var days = Number(this.dataset.daysHidden) || 7;
      return Boolean(this.state.seenAt && Date.now() - this.state.seenAt < days * DAY);
    }

    autoOpen() {
      if (this.autoOpened || this.state.joined || this.isSnoozed()) return;
      // Wait for any other open popup or drawer (cart, menu, search) to close first.
      if (document.querySelector('dialog[open]')) {
        this.timers.push(setTimeout(() => this.autoOpen(), 5000));
        return;
      }
      this.autoOpened = true;
      this.open();
    }

    open() {
      if (this.dialog.open) return;
      this.setTeaser(false);
      this.dialog.showModal();
      this.watchForSignup();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    handleClosed() {
      clearInterval(this.watcher);
      if (this.designMode) return;
      if (!this.state.joined) {
        this.state.seenAt = Date.now();
        this.save();
      }
      this.setTeaser(!this.state.joined);
    }

    // Shopify Forms swaps the email box for its thank-you message after a signup.
    watchForSignup() {
      if (this.designMode || this.state.joined) return;
      var hadEmailBox = false;
      clearInterval(this.watcher);
      this.watcher = setInterval(() => {
        var hasEmailBox = findEmailInputs(this.formArea).length > 0;
        if (hasEmailBox) hadEmailBox = true;
        if (hadEmailBox && !hasEmailBox) {
          clearInterval(this.watcher);
          this.state = { joined: Date.now() };
          this.save();
        }
      }, 700);
    }

    save() {
      if (!this.designMode) write('localStorage', STATE_KEY, this.state);
    }

    setTeaser(visible) {
      if (!this.teaser) return;
      this.teaser.hidden = !(visible && this.dataset.showTeaser === 'true');
    }
  }

  customElements.define('cpv-newsletter-popup', CpvNewsletterPopup);
})();